import React from "react";

import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import { Store } from "~/bff/types/Store";
import { getTestAutomationProps } from "~/helpers/test-automation-props";
import { Nullable } from "~/types/general.types";

import { LinkedStoreCard } from "./components/linked-store-card/component";
import { StoreCarousel } from "./components/stores-carousel/component";
import { NEARBY_STORES_CLASSES } from "./constants";
import { NearbyStoresContainer } from "./styled";

export interface NearbyStoresProps {
  store: Nullable<Store> | undefined;
  nearbyStoresText?: string;
  storeOpenText?: string;
  storeClosedText?: string;
}

export const NearbyStores: React.FC<NearbyStoresProps> = ({
  store,
  nearbyStoresText,
  storeOpenText,
  storeClosedText,
}) => {
  if (!store?.nearbyStores?.length) {
    return null;
  }

  return (
    <NearbyStoresContainer {...getTestAutomationProps("nearby-stores")}>
      <Container>
        <Grid container>
          <Grid item sm={false} xs={false} md={3} />
          <Grid item xs={12} md={6}>
            <Typography
              variant="h2"
              className={NEARBY_STORES_CLASSES.title}
              {...getTestAutomationProps("title")}
            >
              {nearbyStoresText}
            </Typography>
          </Grid>
          <Grid item sm={false} xs={false} md={3} />
        </Grid>
        <Grid container className={NEARBY_STORES_CLASSES.hideOnMobile}>
          <Grid item xs={2} md={2} />
          <Grid item xs={12} md={8}>
            <Grid
              container
              className={NEARBY_STORES_CLASSES.cards}
              {...getTestAutomationProps("stores")}
            >
              {store.nearbyStores.slice(0, 4).map((store, i) => (
                <Grid item md={6} key={i}>
                  <LinkedStoreCard
                    store={store ?? undefined}
                    storeOpenText={storeOpenText}
                    storeClosedText={storeClosedText}
                  />
                </Grid>
              ))}
            </Grid>
          </Grid>
          <Grid item xs={2} md={2} />
        </Grid>
      </Container>
      <StoreCarousel {...getTestAutomationProps("stores")}>
        {store.nearbyStores.map((store, i) => (
          <LinkedStoreCard
            store={store ?? undefined}
            key={i}
            storeOpenText={storeOpenText}
            storeClosedText={storeClosedText}
          />
        ))}
      </StoreCarousel>
    </NearbyStoresContainer>
  );
};
